import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import 'element-plus/es/components/message-box/style/css'
import 'element-plus/es/components/notification/style/css'

import EvansUI from './evans'
import EvMessage from './evans/plugins/EvToast';
import EvConfirm from './evans/plugins/EvConfirm'
import SequencePlugIn from "./evans/plugins/Sequence";
import axios from './axiosConfig'
import ConfigStore from '@/plugins/ConfigStore'
import ElementServices from '@/plugins/ElementServices'
import {progress} from '@/plugins/progress'
import {runStartupUpdates} from '@/platform/updates'

const app = createApp(App)

app.use(store)
app.use(router)
app.use(EvansUI)
app.use(EvMessage)
app.use(EvConfirm)
app.use(ElementServices)
app.use(SequencePlugIn)

app.config.globalProperties.$config = {
  get : (field)=>{
    return store.getters['config/pos'][field]
  },
  check :(key)=>{
    return (new ConfigStore()).check(key);
  }
};

app.config.globalProperties.axios = axios
app.config.globalProperties.$Progress = progress

app.mixin({
  methods: {
    __(ko,en){
      return ko;
    }
  }
});

app.mount('#app')

setTimeout(() => runStartupUpdates(), 1_000)

export default app
